import React from 'react';
import { useSelector } from 'react-redux';
import {
  getRothConversionFromAsArray,
  getRothAllocateToAsArray,
  getRothConversionFundTypeNotDollar,
} from '../../../../redux/modules/rothConversionTransaction/rothConversionTransaction.selectors';
import { currency } from 'src/utils/utils';
import './RothConversionReview.scss';
import { getIsRMDEligible } from '../../../../redux/modules/RMD/RMDSetting.selectors';
import { formatUnixDate } from '../../../../utils/dates/date-utility';
import { TOOLTIP_POSITION_BOTTOM } from '../../../../utils/dom-utils';
import ToolTip from '../../../Shared/ToolTip/ToolTip';
import { getRothConversionTradeDates } from '../../../../redux/modules/executeRothConversion/executeRothConversion.selectors';
import { TRADE_DATE_TOOLTIP } from '../../../../utils/transactions-util';

const RothConversionReview = () => {
  const fromFunds = useSelector(getRothConversionFromAsArray);
  const toFunds = useSelector(getRothAllocateToAsArray);
  const isRMDEligible = useSelector(getIsRMDEligible);
  const fundType = useSelector(getRothConversionFundTypeNotDollar);
  const rothConversionTradeDates = useSelector(getRothConversionTradeDates);

  const traditional = 'TRADITIONAL_IRA';
  const roth = 'ROTH_IRA';
  const rollOver = 'ROLLOVER_IRA';

  return (
    <div>
      <div className="rothconversion-top-title">
        Existing account services and preferences, such as linked bank accounts
        and automatic transactions, will not automatically transfer to the Roth
        IRA as part of the Roth conversion process.
      </div>
      <div>
        {fromFunds.map((fromFund, i) => (
          <div className="roth-conversion-review" key={i}>
            <div className="roth-conversion-from-section">
              {i === 0 && <p className="roth-conversion-review_title">From:</p>}
              <p className="roth-conversion-review_title-mobile">From:</p>
              <div key={fromFund.ticker}>
                {fromFund.agreementType === traditional && (
                  <div className="roth-conversion-review_lower-title">
                    <p className="roth-conversion-review_agreement-type">
                      TRADITIONAL IRA
                    </p>
                  </div>
                )}
                {fromFund.agreementType === rollOver && (
                  <div className="roth-conversion-review_lower-title">
                    <p className="roth-conversion-review_agreement-type">
                      ROLLOVER IRA
                    </p>
                  </div>
                )}
                <div className="roth-conversion-review_new-line">
                  <p className="roth-conversion-review_funds-from-name">
                    {fromFund.fundName}{' '}
                    <span className="roth-conversion-review_ticker">
                      {fromFund.ticker}
                    </span>
                  </p>
                </div>
                <div className="roth-conversion-review_new-line">
                  <p className="blocked_data roth-conversion-review_agreement-number">
                    {fromFund.agreementNumber} •{' '}
                  </p>
                  <p className="blocked_data roth-conversion-review_formatted-entity-names">
                    {fromFund.formattedEntityNames}
                  </p>
                </div>
                <div className="roth-conversion-project-trade-container">
                  <span className="roth-conversion-projected-date">
                    Projected Trade Date:{' '}
                    <span className="review-trade-place-date exchange-review-text-emphasis">
                      {formatUnixDate(
                        rothConversionTradeDates[fromFund.agreementID]
                      )}
                    </span>
                    <ToolTip
                      showBottomBorder={false}
                      message={TRADE_DATE_TOOLTIP}
                      placement={TOOLTIP_POSITION_BOTTOM}
                    />
                  </span>
                </div>
              </div>
            </div>
            <div className="roth-conversion-to-section">
              {i === 0 && <p className="roth-conversion-review_title"> To:</p>}
              <p className="roth-conversion-review_title-mobile"> To:</p>
              <div key={toFunds[i].ticker}>
                {toFunds[i].agreementType === roth && (
                  <div className="roth-conversion-review_lower-title">
                    <p className="roth-conversion-review_agreement-type">
                      ROTH IRA
                    </p>
                    <p>
                      {toFunds[i].newFund && (
                        <p className="roth-conversion-review_new-fund">
                          Just Added
                        </p>
                      )}
                    </p>
                  </div>
                )}
                <p className="roth-conversion-review_funds-to-name">
                  {toFunds[i].fundName}{' '}
                  <span className="roth-conversion-review_ticker">
                    {toFunds[i].ticker}
                  </span>
                </p>
                <div className="roth-conversion-review_new-line">
                  {!toFunds[i].newFund && (
                    <p className="blocked_data roth-conversion-review_agreement-number">
                      {toFunds[i].agreementNumber} •{' '}
                    </p>
                  )}
                  <p className="blocked_data roth-conversion-review_formatted-entity-names">
                    {toFunds[i].formattedEntityNames}
                  </p>
                </div>
              </div>
            </div>
            <div className="roth-conversion-amount-section">
              {i === 0 && (
                <p className="roth-conversion-review_title">Amount:</p>
              )}
              <p className="roth-conversion-review_title-mobile">Amount:</p>
              <div key={toFunds[i].ticker}>
                <div className="roth-conversion-review_lower-title">
                  <p className="roth-conversion-review_agreement-type">TOTAL</p>
                </div>
                <p className="roth-conversion-review_amount">
                  {fromFund.grossUnit === 'SHARES' && (
                    <span>{fromFund.grossAmount} shares</span>
                  )}
                  {fromFund.grossUnit === 'PERCENT' &&
                    fromFund.grossAmount === 100 && (
                      <span>{fromFund.shares} all shares</span>
                    )}
                  {fromFund.grossUnit === 'PERCENT' &&
                    fromFund.grossAmount !== 100 && (
                      <span>{fromFund.grossAmount}%</span>
                    )}
                  {fromFund.grossUnit === 'DOLLAR' && (
                    <span>{currency(fromFund.grossAmount)}</span>
                  )}
                </p>
              </div>
            </div>
            {fundType && (
              <div className="roth-conversion-not-dollar-section">
                {i === 0 && fundType && (
                  <p className="roth-conversion-review_title">
                    Est. Dollar Amount:
                  </p>
                )}
                <p className="roth-conversion-review_title-mobile">
                  Est. Dollar Amount:
                </p>
                {fromFund.grossUnit !== 'DOLLAR' && (
                  <div key={toFunds[i].ticker}>
                    <div className="roth-conversion-review_lower-title">
                      <p className="roth-conversion-review_agreement-type">
                        TOTAL
                      </p>
                    </div>
                    <p className="roth-conversion-review_amount">
                      <span>{currency(fromFund.grossAmountDollars)}</span>
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>

      {isRMDEligible && (
        <div className="roth-conv-div">
          <h3>Required Minimum Distribution</h3>
          <p>
            Just a friendly reminder before you submit the following
            transactions, please make you sure have taken an your required RMD
            from your IRA for this year and the RMD must be satisfied prior to
            any Roth IRA conversions. If you need assistance, please{' '}
            <a
              href="https://www.troweprice.com/personal-investing/help/contact/index.html"
              target="_blank"
              rel="noreferrer"
            >
              contact us
            </a>
            .
          </p>
        </div>
      )}
    </div>
  );
};

export default RothConversionReview;
